import { TriviaItem } from '@repo/types'

export function TriviaItemDisplay({ item }: { item: TriviaItem }) {
  return (
    <div className='flex w-full flex-col justify-center gap-0.5 overflow-hidden'>
      <span className='truncate leading-tight'>{item.question}</span>
      <span className='text-muted truncate text-sm font-semibold uppercase leading-tight tracking-tight'>
        {item.answer}
      </span>
    </div>
  )
}
